import React, { FC, useEffect, useState } from 'react'
import { CircularProgress } from '@material-ui/core';

interface VioletTrafficLightProps {
  total: number;
  onClick?: () => void;
  isActive?: boolean;
  animate?: boolean;
  isLoading?: boolean;
}

const VioletTrafficLight: FC<VioletTrafficLightProps> = ({ total, onClick, isActive = false, animate = false, isLoading = false }) => {
  const [isHovered, setIsHovered] = useState(false);
  const shouldHighlight = isActive || isHovered;
  const hasItems = total > 0;
useEffect(() => {
  if (!document.getElementById('violetTrafficLightPulse')) {
    const style = document.createElement('style');
    style.id = 'violetTrafficLightPulse';
    style.textContent = `
      @keyframes violetTrafficLightPulse {
        @keyframes violetTrafficLightPulse {
          0%, 100% {
            box-shadow: 0 0 12px 6px rgba(128, 0, 128, 1);
            opacity: 1;
          }
          50% {
            box-shadow: 0 0 0px 0px rgba(128, 0, 128, 1);
            opacity: 1;
          }
        }
      `;
    document.head.appendChild(style);
  }
}, []);
  return (
    <div
      onClick={() => hasItems && onClick?.()}
      onMouseEnter={() => hasItems && setIsHovered(true)}
      onMouseLeave={() => hasItems && setIsHovered(false)}
      className={`flex items-center justify-center rounded-full relative ${hasItems ? 'bg-purple-500' : '#080808'}`}
      style={{
        width: '33px',
        height: '33px',
        color: '#000000',
        fontSize: '14px',
        fontWeight: 'bold', 
        cursor: onClick ? 'pointer' : 'default',
        boxShadow: shouldHighlight ? '0 0 14px 3px rgba(128, 0, 128)' : '',
        transform: shouldHighlight ? 'scale(1.1)' : 'scale(1)',
        transition: 'all 0.15s ease'
      }}
    >
      {isLoading
        ? <CircularProgress size={16} style={{ color: 'rgba(128, 0, 128, 1)' }} />
        : total
      }
      <div
        className="flex items-center justify-center rounded-full"
        style={{
          position: 'absolute', 
          top: '0px',
          left: '0px',
          backgroundColor: 'transparent',
          width: '33px',
          height: '33px',
          pointerEvents: 'none',
          zIndex: 1,
          animation: animate
            ? ' violetTrafficLightPulse 1.3s cubic-bezier(0, 2, 0.5, 1) infinite '
            : ''
        }}
      />
    </div>
  );
};

export default VioletTrafficLight